module.exports = __webpack_public_path__ + "img/fi-rr-apps-sort.61ca1fc3.svg";